import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { A3InnuvaLoginStepDocument, A3InnuvaLogoutDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { dateToString, stringToDate } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  owner?: string | null
  createdAt: string
  organizationalUnitId: string
}

export const Logout = ({ owner, createdAt, organizationalUnitId }: Props) => {
  const [A3InnuvaLogOut] = useMutation(A3InnuvaLogoutDocument, {
    extractorFn: (data) =>
      data.payrollIntegrationsA3innuvaMutations.deletePayrollintegrationsA3innuvaOauthToken,
    refetchQueries: [A3InnuvaLoginStepDocument],
  })

  const logout = async () => {
    const result = await A3InnuvaLogOut({
      variables: {
        organizationalUnitId,
      },
    })

    const handled = handleResult(result, () => undefined)
    if (!handled.success) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.error'),
      })
    }
  }

  const syncedBy = owner ? owner : i18n.t('common.unknown')
  const syncedDate = dateToString(stringToDate(createdAt, 'backend_datetime'), 'ui')

  return (
    <Alert color="note">
      <Box flexDirection="column" gap="s16">
        <Text.Normal>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.synced_by',
            {
              synced_by: syncedBy,
              synced_date: syncedDate,
            }
          )}
        </Text.Normal>
        <Button type="secondary" onClick={() => logout()}>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.logout'
          )}
        </Button>
      </Box>
    </Alert>
  )
}
